import styled from '@emotion/styled';

const TooltipWrapper = styled.div`
  display:inline-block;
  position:relative;
  text-align: center;
`;

export default TooltipWrapper;
